import { z } from "zod";

/** Mês do resumo e do extrato ("AAAA-MM"); inválido na URL vira undefined (= mês atual). */
export const commissionsSearch = z.object({
  month: z
    .string()
    .regex(/^\d{4}-\d{2}$/)
    .optional()
    .catch(undefined),
});
export type CommissionsSearch = z.output<typeof commissionsSearch>;
